import { formatFieldValue } from 'form/helpers/field_value_formatter';
import FormActionFactory from "../action/form_action_factory";
import FormFieldTypes from 'form/constants/form_field_types';
import { FormAPI } from 'lecom-api';

export default class FormField {
	_id;
	_formId;
	_name;
	_type;
	_value;
	_rawValue;
	_label;
	_helpText;
	_disabled;
	_hidden;
	_visible;
	_readOnly;
	_optional;
	_errors;
	_actions;
	_className;
	_component;
	_cyclicInitialValue;
	_gridFormParent;
	_maxLength;
	_position;
	_separator;
	_validations;
	_mask;
	_required;
	_initialVisible;
	_lineBreak;
	_prefix;
	_history;
	_historyProps;
	_historyCollapsed;
	_fieldGroupingId;
	_warnings;
	_digits
	_fieldId

	constructor(fieldProps = {}) {
		Object.keys(fieldProps)
		.forEach((propName) => this[propName] = fieldProps[propName]);

		this._actions = this._buildFormActions(fieldProps.actions);
		this._required = false;
	}

	_buildFormActions(actions) {
		return actions ? actions.map((action) => FormActionFactory.create(Object.assign({
			formId: this._formId,
			parentFieldId: this._id,
			gridFormParent: this._gridFormParent
		}, action))) : [];
	}

	_parseValueMaxLength(value) {
		let maxLength = this.maxLength;
		if (this._component === "decimal") maxLength += 1;

		const truncatedValue = String(value).substr(0, (maxLength || String(value).length));
		return ['DECIMAL', 'NUMBER', 'CURRENCY'].includes(this.type) ? +truncatedValue : truncatedValue;
	}


	get historyCollapse() {
		return this._historyCollapse;
	}

	set historyCollapse(value) {
		this._historyCollapse = value;
	}


	get historyProps() {
		return this._historyProps;
	}

	set historyProps(value) {
		this._historyProps = value;
	}


	get history() {
		return this._history;
	}

	set history(value) {
		this._history = value;
	}


	get prefix() {
		return this._prefix;
	}

	set prefix(value) {
		this._prefix = value;
	}


	get actions() {
		return this._actions;
	}

	set actions(actions) {
		this._actions = this._buildFormActions(actions);
	}

	get id() {
		return this._id;
	}

	set id(value) {
		this._id = value;
	}

	get formId() {
		return this._formId;
	}

	set formId(value) {
		this._formId = value;
	}

	get name() {
		return this._name;
	}

	set name(value) {
		this._name = value;
	}

	get type() {
		return this._type;
	}

	set type(value) {
		this._type = value;
	}

	get value() {
		switch (this._type) {
			case (FormFieldTypes.TEXT):
			case (FormFieldTypes.TEXTAREA):
			return formatFieldValue(this._value);
			default:
			return this._value;
		}
	}

	get rawValue() {
		return this._value;
	}

	set value(value) {
		if(typeof value === 'string' || typeof value === 'number') {
			value = this._parseValueMaxLength(value);
		}
		this._value = value;
		this._rawValue = value;
	}

	get label() {
		return this._label;
	}

	set label(value) {
		this._label = value;
	}

	get helpText() {
		return this._helpText;
	}

	set helpText(value) {
		this._helpText = value;
	}

	get disabled() {
		return this._disabled;
	}

	set disabled(value) {
		this._disabled = value;
	}

	get hidden() {
		return this._hidden;
	}

	set hidden(value) {
		this._hidden = value;
	}

	get visible() {
		return this._visible;
	}

	set visible(value) {
		this._visible = value;
	}

	get readOnly() {
		return this._readOnly;
	}

	set readOnly(value) {
		this._readOnly = value;
	}

	get optional() {
		return this._optional;
	}

	set optional(value) {
		this._optional = value;
	}

	get errors() {
		return this._errors;
	}

	set errors(value) {
		this._errors = value;
	}

	get className() {
		return this._className;
	}

	set className(value) {
		this._className = value;
	}

	get component() {
		return this._component;
	}

	set component(value) {
		this._component = value;
	}

	get cyclicInitialValue() {
		return this._cyclicInitialValue;
	}

	set cyclicInitialValue(value) {
		this._cyclicInitialValue = value;
	}

	get gridFormParent() {
		return this._gridFormParent;
	}

	set gridFormParent(value) {
		this._gridFormParent = value;
	}

	get maxLength() {
		return this._maxLength;
	}

	set maxLength(value) {
		this._maxLength = value;
	}

	get position() {
		return this._position;
	}

	set position(value) {
		this._position = value;
	}

	get separator() {
		return this._separator;
	}

	set separator(value) {
		this._separator = value;
	}

	get validations() {
		return this._validations;
	}

	set validations(value) {
		this._validations = value;
	}

	get mask() {
		return this._mask;
	}

	set mask(value) {
		this._mask = value;
	}

	get fieldGroupingId(){
		return this._fieldGroupingId;
	}

	set fieldGroupingId(value){
		this._fieldGroupingId = value;
	}

	set required(value) {
		var requiredValidation;

		if(!requiredValidation){
			requiredValidation = {}
			this._validations.push(requiredValidation);
		}

		if (typeof value === 'object') {
			requiredValidation.required = value.value;
			requiredValidation.formActionName = value.formActionName;
		} else {
			let actions = FormAPI.form(this._formId).actions();
			let formActionName;

			for (let cont = 0, len = actions.length; cont < len; cont++) {
				if (actions[cont].id === 'aprovar') {
					formActionName = 'aprovar';
				} else if (actions[cont].id === 'finish') {
					formActionName = 'finish';
				}
			}

			requiredValidation.required = value;
			requiredValidation.formActionName = formActionName;
		}
	}

	get required() {
		var validations = this._validations || [];
		var requiredValidation;

		for (let cont = 0, len = validations.length; cont < len; cont++) {
			if (validations[cont].hasOwnProperty("required")) {
				requiredValidation = validations[cont];
				break;
			}
		}

		return requiredValidation && requiredValidation.required ? true : false;
	}

	get initialVisible() {
		return this._initialVisible;
	}

	set initialVisible(value) {
		this._initialVisible = value;
	}

	get lineBreak() {
		return this._lineBreak;
	}

	set lineBreak(value) {
		this._lineBreak = value;
	}

	get warnings() {
		return this._warnings;
	}

	set warnings(value) {
		this._warnings = value;
	}

	get digits() {
		return this._digits;
	}

	set digits(value) {
		this._digits = value;
	}

	get optionsUrl() {
		return this._optionsUrl;
	}

	set optionsUrl(value) {
		this._optionsUrl = value;
	}

	get fieldId() {
		return this._fieldId;
	}

	set fieldId(value) {
		this._fieldId = value;
	}
}
